import { Box, Button } from 'braid-design-system';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import BoundedBox from '../BoundedBox/BoundedBox';

import * as styles from './style.css';

interface Props {
  back?: boolean;
}

const NavigationButton = ({ back }: Props) => {
  const style = back ? styles.start : styles.end;
  const label = back ? '< Back' : 'Next >';
  const navigate = useNavigate();

  return (
    <Box className={style}>
      <BoundedBox width={150}>
        {!back && <Button type="submit">{label}</Button>}
        {back && <Button onClick={() => navigate(-1)}>{label}</Button>}
      </BoundedBox>
    </Box>
  );
};

export default NavigationButton;
